import {observer} from "mobx-react-lite"
import React from "react"
import CategoryCompare from "../store/entities/CategoryCompare"
import {AsyncCategorySelection} from "./AsyncCategorySelection"
import './../store/entities/priceMarkup/CategoryWithMarkUp.scss'

export const CategoriesCompareTable = observer(({categories}: { categories: CategoryCompare[] }) => {

    return <React.Fragment>{categories.map((parent_category, index) => {
        const category = parent_category.lastCategory
        const hasChildren = category.children.length > 0

        return <React.Fragment key={category.wa_category_id + "_" + index}>
            <div className={"category-row flexbox full-width bordered-bottom"}>
                <div className={"category-row__name wide custom-px-16 custom-py-12 width-50"} style={{display: 'flex'}}>
                    {hasChildren &&
                    <span className={`children-toggler ${!category.is_collapsed && "show"} custom-px-4 cursor-pointer`}
                          onClick={() => category.is_collapsed = !category.is_collapsed}>
                    </span>
                    }
                    <div style={{display: 'flex', width: '100%'}}>
                        <div style={{width: '42%'}}>
                            {category.wa_category_name}({category.count})
                            <a className={"custom-ml-4 gray smaller"} href={category.url} target={"_blank"} rel="noopener noreferrer">
                                <i className="fas fa-external-link-alt" aria-hidden="true"/>
                            </a>
                        </div>

                        <div style={{width: '10%'}}><i className="fa fa-angle-right gray" aria-hidden="true"/></div>
                        <div style={{width: '48%'}} className={"width-50 custom-px-0"}><AsyncCategorySelection entity={category}/></div>
                    </div>

                </div>

            </div>
            {hasChildren && !category.is_collapsed && <div style={{paddingLeft: 10}}>
                <CategoriesCompareTable categories={category.children}/>
            </div>}
        </React.Fragment>
    })}
    </React.Fragment>
})